module.exports = __webpack_public_path__ + "img/Cvent.2c103996.svg";